import React, { useState } from 'react';
import { Eye, EyeOff, LogIn } from 'lucide-react';
import LoginHeader from './Modules/LoginHeader';
import LoginForm from './Modules/LoginForm';
import LoginStats from './Modules/LoginStats';
import { getProFile, loginUser } from '../services/Queries/Auths';
import { useAuths } from '../context/AuthProviders';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const {login} = useAuths();
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!email || !password){
      setError('Email and Password are required');
      setIsLoading(false);
      return;
    }

    try {
      const result = await loginUser(email, password);
      console.log('Login Result:', result);
      
      // Check if we have a session
      if (result?.session) {

        let profileData = null;
        let userType = 'user';
        try {
          profileData = await getProFile();
          userType = profileData?.user_type || 'user';
        } catch (error) {
          console.log('Error fetching Profile: ', error)
        }
        // Store the session data properly
        const userData = {
          id: result.user?.id,
          email: result.user?.email,
          role: result.user?.role,
          user_metadata: result.user?.user_metadata,
          profile: profileData,
          last_sign_in: result.user?.last_sign_in_at
        };
        
        login(userData, result.session)
        // Store in localStorage (stringify objects)
        localStorage.setItem('sb-user', JSON.stringify(userData));
        localStorage.setItem('sb-access-token', result.session.access_token);
        localStorage.setItem('sb-refresh-token', result.session.refresh_token);
        localStorage.setItem('sb-expires-at', result.session.expires_at);
        
        console.log('User stored in localStorage:', userData);
        
        
        // Redirect to dashboard
        if (userType === 'user') {
          window.location.href = '/apply-hr';
          return;
        } else if (userType === 'hr' || userType === 'admin') {
          window.location.href = '/hr/dashboard';
          return;
        } else {
          // Fallback for any other role
          window.location.href = '/';
        }
      } else {
        throw new Error('No session returned from login');
      }
      
      setIsLoading(false);
      setError('');
    } catch (error) {
      console.error('Login Error:', error.message);
      setIsLoading(false);
      setError(error.message || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #0095fa 0%, #0f6caa 100%)' }}>
      {/* Decorative elements */}
      <div className="fixed top-0 left-0 w-full h-full pointer-events-none overflow-hidden">
        {/* Top right accent */}
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full" style={{ backgroundColor: '#ffffff', opacity: 0.1 }} />
        {/* Bottom left accent */}
        <div className="absolute -bottom-40 -left-40 w-96 h-96 rounded-full" style={{ backgroundColor: '#ffffff', opacity: 0.08 }} />
      </div>

      {/* Main container */}
      <div className="relative z-10 w-full max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left side - Login Form */}
          <div className="flex flex-col justify-center bg-white rounded-2xl p-8 md:p-10 shadow-xl" style={{ boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)' }}>
            <LoginHeader />
            
            <LoginForm
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              onSubmit={handleLogin}
              isLoading={isLoading}
              error={error}
            />
          </div>

          {/* Right side - Stats Cards */}
          <div className="hidden md:flex flex-col justify-center space-y-6">
            <LoginStats />
          </div>
        </div>

        {/* Mobile stats - show on small screens */}
        <div className="md:hidden mt-8">
          <LoginStats />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;